var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3998,
    cy: 27.5999,
    r: 27.6,
    transform: "rotate(-90 28.3998 27.5999)",
    fill: "#2C4530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8089 28.5444C42.3304 28.0229 42.3304 27.1773 41.8089 26.6558L33.3099 18.1568C32.7884 17.6353 31.9428 17.6353 31.4213 18.1568C30.8997 18.6783 30.8997 19.5239 31.4213 20.0455L38.9759 27.6001L31.4213 35.1547C30.8997 35.6763 30.8997 36.5219 31.4213 37.0434C31.9428 37.5649 32.7884 37.5649 33.3099 37.0434L41.8089 28.5444ZM15.9355 28.9356L40.8646 28.9356V26.2646L15.9355 26.2646L15.9355 28.9356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogright);
export default __webpack_public_path__ + "static/media/blogright.63255d17f34c8b490bb806de82d2612e.svg";
export { ForwardRef as ReactComponent };